<template>
  <div class="container">
    <ContractWrapper>
      <ContractLocale class="no-print" />
      <Header></Header>
      <Parties />
      <Agreement />
      <ConfidentialInfo />
      <SupplierObligations />
      <ContractDuration />
      <Violation />
      <ApplicableLaw />
      <Signature />
    </ContractWrapper>
  </div>
</template>

<script>
import ContractWrapper from "../../../../shared/components/ContractWrapper";
import ContractLocale from "./ContractLocale";
import Header from "./Header";
import Parties from "./PartiesOutput";
import Agreement from "./AgreementOutput";
import ConfidentialInfo from "./ConfidentialInfo";
import SupplierObligations from "./SupplierObligations";
import ContractDuration from "./ContractDuration";
import Violation from "./Violation";
import ApplicableLaw from "./ApplicableLaw";
import Signature from "./Signature";
export default {
  components: {
    ContractWrapper,
    ContractLocale,
    Header,
    Parties,
    Agreement,
    ConfidentialInfo,
    SupplierObligations,
    ContractDuration,
    Violation,
    ApplicableLaw,
    Signature,
  },
};
</script>



// WEBPACK FOOTER //
// src/apps/hemmelig/components/contract/Contract.vue